/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BuildingRoofType {
    Hart = 'Hart',
    Weich = 'Weich'
  }

    export const BuildingRoofTypeTranslocoMap: Record<BuildingRoofType, string> = {
    [BuildingRoofType.Hart]: 'buildingRoofType.hart',
    [BuildingRoofType.Weich]: 'buildingRoofType.weich',
    };

    export const BuildingRoofTypeOptions = [
  { value: BuildingRoofType.Hart, labelKey: 'buildingRoofType.hart' },
  { value: BuildingRoofType.Weich, labelKey: 'buildingRoofType.weich' },
    ];

